import invariant from 'invariant';
import { useEffect } from 'react';
import { useTheme } from '@signavio/ui';
function useGreyBody() {
  const {
    color
  } = useTheme();
  useEffect(() => {
    invariant(document.body, 'document.body does not exist');
    document.body.style.backgroundColor = color.background;
    return () => {
      invariant(document.body, 'document.body does not exist');
      document.body.style.backgroundColor = color.surface;
    };
  });
}
export default useGreyBody;